(function () {
  var productData = null;

  function getProductData() {
    if (productData) return Promise.resolve(productData);
    var match = window.location.pathname.match(/\/products\/([^/?]+)/);
    if (!match) return Promise.resolve(null);
    return fetch('/products/' + match[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) { productData = data; return data; });
  }

  function filterGallery(featuredMediaId) {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var items = Array.from(gallery.querySelectorAll('li.product-media-container'));
    var targetIndex = 0;
    items.forEach(function (item, index) {
      if (!featuredMediaId || item.id.includes(String(featuredMediaId))) {
        item.style.display = '';
        targetIndex = index;
      } else {
        item.style.display = 'none';
      }
    });
    if (gallery.slideshow) gallery.slideshow.select(targetIndex);
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-variant-id]');
    if (!input) return;
    var variantId = parseInt(input.getAttribute('data-variant-id'));
    getProductData().then(function (product) {
      if (!product) return;
      var variant = product.variants.find(function (v) { return v.id === variantId; });
      if (variant && variant.featured_media) {
        filterGallery(variant.featured_media.id);
      } else {
        filterGallery(null);
      }
    });
  });

  // Filter on page load
  setTimeout(function () {
    var checked = document.querySelector('[data-variant-id][checked]');
    if (!checked) return;
    var variantId = parseInt(checked.getAttribute('data-variant-id'));
    getProductData().then(function (product) {
      if (!product) return;
      var variant = product.variants.find(function (v) { return v.id === variantId; });
      if (variant && variant.featured_media) filterGallery(variant.featured_media.id);
    });
  }, 500);
})();